<template>

  <div class="element">

    <map-marker v-if="element.type === 'marker'"
                :element="element"
                :active="active"
                @click="$emit('click', element)"
                @menu="contextmenu($event)"
                @save="update($event)"/>

    <map-polygon v-if="element.type === 'polygon'"
                 :element="element"
                 :active="active"
                 @click="$emit('click', element)"
                 @menu="contextmenu($event)"
                 @save="update($event)" />

    <map-polyline v-if="element.type === 'polyline'"
                  :element="element"
                  :active="active"
                  @click="$emit('click', element)"
                  @menu="contextmenu($event)"
                  @save="update($event)" />

    <map-rectangle v-if="element.type === 'rectangle'"
                 :element="element"
                 :active="active"
                 @click="$emit('click', element)"
                 @menu="contextmenu($event)"
                 @save="update($event)" />

    <map-circle v-if="element.type === 'circle'"
                   :element="element"
                   :active="active"
                   @click="$emit('click', element)"
                   @menu="contextmenu($event)"
                   @save="update($event)" />
  </div>

</template>

<script>

import { mapActions } from 'vuex'
import MapMarker from './elements/map-marker'
import MapPolygon from './elements/map-polygon'
import MapPolyline from './elements/map-polyline'
import MapRectangle from './elements/map-rectangle'
import MapCircle from './elements/map-circle'

export default {
  name: 'map-element',

  props: [ 'element', 'selected', 'locked' ],

  data () {
    return {

    }
  },

  computed: {
    selectable () {
      return this.element.assetId || !this.locked
    },

    active () {
      return this.selectable && this.selected === this.element
    }
  },

  methods: {
    ...mapActions('map', [
      'select',
      'save'
    ]),

    contextmenu (event) {
      if (this.locked)
        return

      this.select(this.element)
      this.$emit('menu', event)
    },

    update (data) {
      this.save(Object.assign(this.element, data))
    }
  },

  components: {
    MapMarker,
    MapPolygon,
    MapPolyline,
    MapRectangle,
    MapCircle
  }
}

</script>

<style lang="scss" scoped>

</style>
